// Please keep this in sync between ops-tools and merchant-admin.

import React from 'react';

import VatCategoriesSelect from './VatCategoriesSelect';
import { VatCategoryT, VatFieldValue } from './types';

type VatCategoriesProps = {
  value: VatFieldValue;
  onChange: (value: VatFieldValue) => void;
  invalid?: boolean;
  disabled?: boolean;
  vatCategories: VatCategoryT[] | undefined;
  lang?: string;
  clearable?: boolean;
};

const MANUAL_CATEGORY_CODE = 'MANUAL';

/**
 * Input of manual VAT has been removed from the UI, but we still need to support rendering it for existing items/offers that have a manual value saved
 */
const enrichWithManualValue = (vatCategories: VatCategoryT[], value: VatFieldValue): VatCategoryT[] => {
  if (!value.categoryCode && value.percentage !== undefined) {
    return vatCategories.concat([
      {
        code: MANUAL_CATEGORY_CODE,
        label: [],
        vat_percentage: value.percentage,
      },
    ]);
  }

  return vatCategories;
};

export const VatCategories = ({
  value,
  onChange,
  invalid,
  disabled,
  vatCategories,
  lang = 'en',
  clearable = false,
}: VatCategoriesProps) => {
  if (!vatCategories) {
    if (typeof value.percentage === 'number') {
      return <>{value.percentage}%</>;
    } else {
      return <>-</>;
    }
  }
  return (
    <VatCategoriesSelect
      vatCategories={enrichWithManualValue(vatCategories, value)}
      disabled={disabled}
      invalid={invalid}
      lang={lang}
      value={value.categoryCode ?? MANUAL_CATEGORY_CODE}
      onChange={newCategoryCode =>
        onChange({
          type: newCategoryCode === MANUAL_CATEGORY_CODE ? 'manual' : 'categories',
          categoryCode: newCategoryCode,
          percentage: vatCategories.find(vc => vc.code === newCategoryCode)?.vat_percentage,
        })
      }
      clearable={clearable}
    />
  );
};
